module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать дом\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'building-details',
        params: {
          building_id: _vm.building.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям дома")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.building.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteBuilding.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить дом")]) : _vm._e()]), _vm._v(" "), _c('building-edit-form', {
    attrs: {
      "building": _vm.building
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6dcdf92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/building/BuildingEdit.vue
// module id = 697
// module chunks = 0